<div class="col-md-12" id="cfet-verification-pending-container">
  <picture>
    <source media="(min-width: 767px)" srcset="assets/images/Group.png">
    <img id="verification-pending-icon" src="assets/images/Group.png" alt="pending verification icon">
  </picture>

  <div class="row" id="pending-verification-content">
    <div class="col-md-12">
      <h2 id="pending-verification-heading">
        <strong>{{cfetLabels.cfet_verification_information.verification_pending_heading}}</strong></h2>
      <p id="pending-verification-desc">{{cfetLabels.cfet_verification_information.verification_pending_desc}}</p>
    </div>
  </div>

  <div class="row col-md-12" id="pending-verification-footer-column">
    <button type="button" id="btn-continue" (click)="continueToDocUpload($event)" (keyup)="continueToDocUpload($event)"
      class="btn btn-alt btn-medium" tabindex="0">{{cfetButtonLabels.button_labels.documentVerification}}</button>
  </div>

</div>